module.exports = __webpack_public_path__ + "img/assoc_cat_gruppi.75ad1014.png";